import ReadSmore from 'read-smore'

const readMores = document.querySelectorAll('.js-read-smore');
const readMoresButton = document.querySelector('.js-read-smore');

const options = {
  blockClassName: 'read-more',
  moreText: readMoresButton.getAttribute('data-more-text'),
  lessText: readMoresButton.getAttribute('data-less-text'),
}

ReadSmore(readMores, options).init()
